import { Controller } from '@hotwired/stimulus'
import { unDisableButton } from '@/controllers/shared/utils/loading_button.js'

// Connects to data-controller="cloudflare-turnstile"
export default class extends Controller {
  static targets = ['turnstileElement', 'submitButton']

  connect() {
    if (typeof turnstile !== 'undefined') {
      this.initializeTurnstile()
    } else {
      window.onloadTurnstileCallback = () => this.initializeTurnstile()
    }
  }

  initializeTurnstile() {
    // eslint-disable-next-line no-undef
    turnstile.render(this.turnstileElementTarget, {
      sitekey: this.turnstileElementTarget.dataset.sitekey,
      size: 'flexible',
      callback: () => {
        unDisableButton(this.submitButtonTarget)
      }
    })
  }
}
